import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Anchor, Button } from '@mantine/core'
import { randomArrayItem } from '@utils/randomArrayItem'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import ExampleUser from '@assets/exampleUser.png'
import { randomBool } from '@utils/randomBool'
import { DataGridList } from '@components/DataGrid/DataGridList'

const MOCK_DATA = Array(30)
  .fill(0)
  .map((_, i) => {
    return {
      id: `staff-list-${i}`,
      status: randomArrayItem(['Active', 'Inactive']),
      number: (
        <Anchor href="tel:+1 (212) 555-1212" c="dark">
          +1 (212) 555-1212
        </Anchor>
      ),
      email: (
        <Anchor href="mailto:info@example.com" c="dark">
          info@example.com
        </Anchor>
      ),
      phone: (
        <Anchor href="tel:+1 (212) 555-1212" c="dark">
          +1 (212) 555-1212
        </Anchor>
      ),
      locations: randomBool() ? (
        'All'
      ) : (
        <DataGridList
          title="Locations"
          data={['Some', 'Another', 'And another']}
        />
      ),
      permissions: randomArrayItem(['Admin', 'Read-only', 'Custom']),
      twoStep: randomArrayItem(['Enrolled', 'Not enrolled']),
      lastLogin: randomArrayItem(['Today', '6w 3d', '2mo 21d']),
    }
  })

export const PermissionSetsStaff = () => {
  const navigate = useNavigate()

  const handleNavigate = () =>
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            title: 'Members',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
        ],
      },
    })

  const columns: DataGridColumns[] = [
    {
      label: 'Name',
      prop: 'name',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Email',
      prop: 'email',
    },
    {
      label: 'Phone',
      prop: 'phone',
    },
    {
      label: 'Locations',
      prop: 'locations',
    },
    {
      label: 'Last login',
      prop: 'lastLogin',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'Active Staff',
      href: '#',
      default: true,
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Edit permissions',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Edit permissions',
      onClick: (items: any) => console.log('Selected Actions: Tags'),
    },
  ]

  const data = MOCK_DATA.map((curr, i) => {
    return {
      ...curr,
      name: (
        <DataGridPerson
          name="Alfredo Carrillo"
          status="online"
          image={ExampleUser}
          onClick={handleNavigate}
        />
      ),
    }
  })

  return (
    <DataGrid
      data={data}
      columns={columns}
      sections={sections}
      actions={actions}
      results={data.length}
      buttons={<Button>Invite staff</Button>}
      selectedActions={selectedActions}
      page={1}
    />
  )
}
